import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigServiceProvider} from "../../../core/services/config-service/config-service";
import {StorageServiceProvider} from "../../../core/services/storage-service/storage-service";
import {Observable} from "rxjs/Observable";
import {ClientServiceProvider} from '../../../clients/services/client-service/client-service';
import {Audit} from "../../../clients/pages/clients-audits/clients-audits";


@Injectable()
export class AuditsServiceProvider {
  private _products: Array<any> = [];

  constructor(private http: HttpClient,
              private clientService: ClientServiceProvider,
              private configService: ConfigServiceProvider,
              private storageService: StorageServiceProvider) {
  }

  getAuditForClient(clientId: number): Observable<any> {
    return this.http.get(this.configService.getUrl('auditClient').replace('{clientId}', clientId.toString()))
  }

  getQuestionForClient(clientId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('questionClient').replace('{clientId}', clientId.toString()))
        .toPromise()
        .then(question => {
          this._products = [];
          Object.keys(question).map(index => {
            this._products.push(question[index]);
          });
          this.storageService.setObject('question', question);
          resolve(this._products);
        })
        .catch(reason => {
          console.error(reason);
          reject(reason)
        });
    })
  }

  getQuestionForAudit(auditId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('questionAudit').replace('{auditId}', auditId.toString()))
        .toPromise()
        .then(question => {
          this._products = [];
          Object.keys(question).map(index => {
            this._products.push(question[index]);
          });
          this.storageService.setObject('question', question);
          resolve(this._products);
        })
        .catch(reason => {
          console.error(reason);
          reject(reason)
        });
    })
  }

  sendAudit(audit: Audit): Observable<any> {
    return this.http.post(this.configService.getUrl('audit'), audit);
  }


  get products() {
    return this._products;
  }

  set products(value) {
    this._products = value;
  }

}



// WEBPACK FOOTER //
// ./src/modules/audits/services/audits-service/audits-service.ts